var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-location.37ecaf1e.png","uri@3x": __webpack_public_path__ + "icon-location.4ef9ad63.png","uri@2x": __webpack_public_path__ + "icon-location.5e4603ec.png",
    width: 15,
    height: 20
});